<template lang="pug">
  .filter-sheet
    y-bottom-sheet(v-model="showSheet" inset scrollable max-width="600px")
      v-card(flat)
        v-card-title.px-4
          div.h6.basic800--text {{ $t('filter_income') }}
          v-spacer
          v-btn(color="white" text @click="clearFilters")
            .button-Aa-small.primary400--text {{ $t('clear_filters') }}
          v-btn(color="textColorAccent" depressed height=32 dark @click="filterData")
            .button-AA-small.basic100--text {{ $t('filter') }}
        v-divider.basic300
        v-card-text.px-4.pb-8
          .status.mt-4
            p.mb-1.label.basic600--text.text-uppercase {{ $t('payment_status') }}
            v-select.mt-2(item-color="basic100" v-model="status" :items="statusSelections" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")
          .overdue.mt-4
            p.mb-1.label.basic600--text.text-uppercase {{ $t('overdue') }}
            v-select.mt-2(item-color="basic100" v-model="overdue" :items="overdueSelections" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")
          .reminder.mt-4
            p.mb-1.label.basic600--text.text-uppercase {{ $t('reminder') }}
            v-select.mt-2(item-color="basic100" v-model="reminder" :items="reminderSelections" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")
          //- .category.mt-4
            p.mb-1.label.basic600--text.text-uppercase category
            v-select.mt-2(item-color="basic100" v-model="category" :items="categorySelections" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")
          .date.mt-4
            div.d-flex
              p.mb-1.label.basic600--text.text-uppercase {{ $t('record_date') }}
              v-spacer
              p.mb-1.c1.basic600--text(v-if="range.id === 'custom' && selectedDateRange.length > 0")
                template(v-if="selectedDateRange.length > 1") {{ selectedDateRange[0] | humanizeDate }} ~ {{ selectedDateRange[1] | humanizeDate }}
                template(v-else) {{ selectedDateRange[0] | humanizeDate }}
            v-select.mt-2(item-color="basic100" v-model="range" :items="dateRangeSelections" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")
              template(v-slot:item="{ item }")
                v-list-item-content(v-if="item.value.id === 'custom'" @click="customDateRangePickerDialog = true")
                  v-list-item-title {{ item.text }}
                v-list-item-content(v-else)
                  v-list-item-title {{ item.text }}
                  //- v-list-item-action(v-if="item.value === 'custom'")
                    v-btn.mr-2.black--text(color="black" depressed outlined x-small @click.stop="clickShowFormExample(item.value)") Example

    
    .modals
      date-range-picker-dialog(:dialog.sync="customDateRangePickerDialog" @selected="dateRangeSelected($event)")

</template>

<script>
import DateRangePickerDialog from '../../views/admin/database/DateRangePickerDialog.vue'
export default {
  name: 'FilterDatabaseSheet',
  components: { DateRangePickerDialog},
  props: ['open', 'company', 'filtered', 'role'],
  data: () => ({
    status: { name: 'All', id: '' },
    overdue: { name: 'All', id: '' },
    reminder: { name: 'All', id: '' },
    // category: { name: 'All', id: ''},
    range: { name: 'All', id: '' },
    selectedDateRange: [],
    statusSelections: [
      { text: 'All', value: { name: 'All', id: '' } },
      { text: 'Paid', value: { name: 'Paid', id: 'paid' } },
      { text: 'Unpaid', value: { name: 'Unpaid', id: 'unpaid' } },
    ],
    overdueSelections: [
      { text: 'All', value: { name: 'All', id: '' } },
      { text: 'Yes', value: { name: 'Overdue', id: 'yes' } },
      { text: 'No', value: { name: 'Not Yet Due', id: 'no' } },
    ],
    reminderSelections: [
      { text: 'All', value: { name: 'All', id: '' } },
      { text: 'Sent', value: { name: 'Sent', id: 'sent' } },
      { text: 'Unsent', value: { name: 'Unsent', id: 'unsent' } },
    ],
    // categorySelections: [
    //   { text: 'All', value: { name: 'All', id: '' } },
    //   { text: 'Sales', value: { name: 'Sales', id: '1' } },
    //   { text: 'Capital', value: { name: 'Capital', id: '2' } },
    //   { text: 'Loan', value: { name: 'Loan', id: '3' } },
    // ],
    dateRangeSelections: [
      { text: 'All', value: { name: 'All', id: '' } },
      { text: 'Today', value: { name: 'Today', id: 'today' } },
      { text: 'Yesterday', value: { name: 'Yesterday', id: 'yesterday' } },
      { text: 'Past 7 days', value: { name: 'Past 7 days', id: 'week' } },
      { text: 'This month', value: { name: 'This month', id: 'month' } },
      { text: 'This year', value: { name: 'This year', id: 'year' } },
      { text: 'Custom', value: { name: 'Custom', id: 'custom' } }
    ],
    customDateRangePickerDialog: false,
  }),
  computed: {
    showSheet: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {

  },
  mounted () {
    if (this.filtered.status) {
      this.status = this.filtered.status
    } if (this.filtered.overdue) {
      this.overdue = this.filtered.overdue
    }if (this.filtered.reminder) {
      this.reminder = this.filtered.reminder
    } 
    // if (this.filtered.category) {
    //   this.category = this.filtered.category
    // } 
    if (this.filtered.range) {
      this.range = this.filtered.range
    } 
    if (this.filtered.selectedDateRange) {
      this.selectedDateRange = this.filtered.selectedDateRange
    }
  },
  methods: {
    filterData () {
      let data = {}
      if (this.status.id) {
        data.status = this.status
      }
      if (this.overdue.id) {
        data.overdue = this.overdue
      }
      if (this.reminder.id) {
        data.reminder = this.reminder
      }
      // if (this.category.id) {
      //   data.category = this.category
      // }
      if (this.range.id) {
        data.range = this.range
        data.selectedDateRange = this.selectedDateRange
      }
      this.$emit('filtered', data)
      this.showSheet = false
    },
    clearFilters () {
      this.status = { name: 'All', id: '' }
      this.overdue = { name: 'All', id: '' }
      this.reminder = { name: 'All', id: '' }
      // this.category = { name: 'All', id: ''}
      this.range = { name: 'All', id: '' }
      this.selectedDateRange = []
      this.filterData()
    },
    dateRangeSelected (dates) {
      this.selectedDateRange = dates
      this.range = { name: 'Custom' , id: 'custom' }
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white;
}
</style>

<i18n>
{
  "en": {
    "filter_income": "Filter income"
  },
  "id": {
    "filter_income": "Filter pendapatan"
  }
}
</i18n>